import { Button } from "./Button";

export const NextLevelJobsBlogCTA: React.FC<{ className?: string }> = ({
  className = "",
}) => {
  return (
    <div
      className={`bg-gray-800 flex flex-col p-6 rounded-xl shadow-md mt-8 mb-8 md:-mx-6 ${className}`}
    >
      <h3 className="text-xl font-semibold text-gray-100 mb-4">
        About Next Level Jobs EU
      </h3>
      <p className="text-gray-300 mb-3">
        Next Level Jobs EU is a premium job board dedicated to connecting top
        talent with the highest paying companies in Europe.
      </p>
      <p className="text-gray-300 mb-3">
        We only list companies that can pay 100k+ for senior software engineers.
      </p>
      <div className="mr-auto mt-4">
        <Button to="/">Sign up for the newsletter</Button>
      </div>
    </div>
  );
};
